import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import { random } from 'rambdax-v11';

export class CryptoService {
  constructor(private _crypto: Crypto) {}

  public randomUUID(): string {
    try {
      return this._crypto.randomUUID();
    } catch (_err: any) {
      return random(0, 100000000).toString();
    }
  }
}

export function provideCryptoService(): CryptoService {
  return provideSingleton(CryptoService, () => new CryptoService(crypto));
}
